export default "__VITE_ASSET__DfdxE7WH__"